import React, { useEffect, useState } from 'react'

import { TableRow, TableCell } from 'components/Table'
import { AvatarIcon } from '../ListCompanies/components'
import InfiniteScrollList from '../InfiniteScrollList'

import { Box, Typography, IconButton, makeStyles } from '@material-ui/core'

import { ArrowRight as ArrowIcon, Star as StarIcon } from 'react-feather'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import { getBaseURL } from 'service/env'

import constants from 'constants/index'

import styles from './styles'

const useStyles = makeStyles(styles)

const TableRowOrganization = ({
  userOrganization,
  isFavorite,
  favoriteId,
  onFavoriteChange,
  ...rest
}) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const [currentFavoriteId, setCurrentFavoriteId] = useState(favoriteId ?? null)
  const [isSelecting, setIsSelecting] = useState(false)

  useEffect(() => {
    setCurrentFavoriteId(favoriteId ?? null)
  }, [favoriteId])

  const kindLabel =
    constants.organizations.KIND_LABELS[userOrganization?.kind] ??
    userOrganization?.kind

  const handleClick = async () => {
    setIsSelecting(true)
    const newWindow = window.open('', '_blank')
    try {
      const response = await service.dponet.organizations.select(
        userOrganization.id,
      )

      const authToken = response?.data?.authToken

      if (!authToken) {
        if (newWindow) newWindow.close()
        setIsSelecting(false)
        return snackbar.open({
          message:
            'Ocorreu um erro ao acessar a organização! Verifique se você ainda pertence à essa organização',
          variant: 'error',
        })
      }

      const link = `/transparent-login/${authToken}/${userOrganization.id}`
      const advisorUrl = `${getBaseURL('advisorPortal')}${link}`
      if (newWindow) {
        newWindow.location.href = advisorUrl
      } else {
        window.open(advisorUrl, '_blank')
      }
      setIsSelecting(false)
    } catch (error) {
      if (newWindow) newWindow.close()
      setIsSelecting(false)
      snackbar.open({
        message: 'Ocorreu um erro ao selecionar organização!',
        variant: 'error',
      })
    }
  }

  const handleAutoRedirect = async () => {
    try {
      const response = await service.dponet.organizations.select(
        userOrganization.id,
      )
      const authToken = response?.data?.authToken
      if (!authToken) return
      const link = `/transparent-login/${authToken}/${userOrganization.id}`
      window.location.href = `${getBaseURL('advisorPortal')}${link}`
    } catch {
      snackbar.open({
        message: 'Ocorreu um erro ao redirecionar para a organização',
        variant: 'error',
      })
    }
  }

  const handleFavorite = async (e) => {
    e.stopPropagation()
    try {
      if (currentFavoriteId) {
        await service.dponet.companyFavorites.destroy({
          companyFavoriteId: currentFavoriteId,
        })
        setCurrentFavoriteId(null)
        onFavoriteChange(userOrganization.id, false)
      } else {
        const response = await service.dponet.companyFavorites.create({
          favoritableId: userOrganization?.id,
          favoritableType: 'Organization',
        })
        const newFavoriteId = response?.data?.companyFavorite?.id
        setCurrentFavoriteId(newFavoriteId)
        onFavoriteChange(userOrganization.id, true)
      }
    } catch (error) {
      snackbar.open({
        message: 'Ocorreu um erro ao atualizar favorito! Tente novamente',
        variant: 'error',
      })
    }
  }

  useEffect(() => {
    const redirectTo = sessionStorage.getItem('redirectTo')
    const organizationId = Number(sessionStorage.getItem('organizationId'))

    if (redirectTo && organizationId === userOrganization?.id)
      handleAutoRedirect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrganization.id])

  return (
    <TableRow
      className={classes.tableRow}
      pointer
      onClick={handleClick}
      {...rest}
    >
      <TableCell style={{ width: '100%', maxWidth: 0, overflow: 'hidden' }}>
        <Box display="flex" alignItems="center">
          <AvatarIcon company={userOrganization} />
          <Box ml={1} minWidth={0} overflow="hidden">
            <Typography noWrap>{userOrganization?.name}</Typography>
            <Typography noWrap className={classes.document}>
              Finalidade: {kindLabel}
            </Typography>
          </Box>
        </Box>
      </TableCell>
      <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
        <IconButton onClick={handleFavorite}>
          <StarIcon
            className={isFavorite ? classes.starActive : classes.starInactive}
            fill={isFavorite ? 'currentColor' : 'none'}
          />
        </IconButton>
        <IconButton
          onClick={(event) => {
            event.stopPropagation()
            handleClick()
          }}
          disabled={isSelecting}
        >
          <ArrowIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

const ListOrganizations = ({
  usersOrganizations,
  onLoadMore,
  isLoadingMore,
}) => {
  const classes = useStyles()

  return (
    <InfiniteScrollList
      items={usersOrganizations}
      onLoadMore={onLoadMore}
      scrollbarClassName={classes.perfectScrollbar}
      isLoadingMore={isLoadingMore}
      renderRow={(item, isFavorite, onFavoriteChange) => (
        <TableRowOrganization
          key={item.id}
          userOrganization={item}
          isFavorite={isFavorite}
          favoriteId={item.favoriteId}
          onFavoriteChange={onFavoriteChange}
        />
      )}
    />
  )
}

export default ListOrganizations
